import type { TrackingConsentBanner, TrackingConsentCategoryKey, TrackingConsentCopyKey } from '../types';

export type TrackingConsentCategoryTranslation = {
  name: string;
  purpose: string;
};

export type TrackingConsentCategoryLabels = Readonly<
  Record<'strictly_necessary' | 'analytics' | 'marketing', TrackingConsentCategoryTranslation>
>;

export interface TrackingConsentLocale {
  copy: Readonly<Required<Pick<TrackingConsentBanner, TrackingConsentCopyKey>>>;
  categories: TrackingConsentCategoryLabels;
}

export const isTrackingConsentCategoryKey = (
  key: TrackingConsentCategoryKey
): key is keyof TrackingConsentCategoryLabels =>
  key === 'strictly_necessary' || key === 'analytics' || key === 'marketing';
